module.exports = __webpack_public_path__ + "img/valorSindhoteis.2c75d8ff.png";